module.exports = __webpack_public_path__ + "static/img/RAPW1000_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPW1000_1.png
// module id = 2Hug
// module chunks = 0